export default [
  {
    path: '/dictionary',
    name: 'dictionary',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/DictionaryList.vue'),
    meta: {},
  },

  // Chương
  {
    path: '/dictionary/budgetchapter',
    name: 'budgetchapter',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/budgetChapter/BudgetChapterList.vue'),
    meta: {},
  },
  // Loại khoản
  {
    path: '/dictionary/budgetkinditem',
    name: 'budgetkinditem',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/budgetKindItem/BudgetKindItemList.vue'),
    meta: {},
  },
  // Mục, tiểu mục thu
  {
    path: '/dictionary/budgetitemCollect',
    name: 'budgetitemCollect',
    component: () =>
      import(/* webpackChunkName:'di'*/ '@/views/dictionary/budgetItemCollect/BudgetItemCollectList.vue'),
    meta: {},
  },
  // nguồn kinh phí
  {
    path: '/dictionary/budgetsource',
    name: 'budgetsource',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/budgetSource/BudgetSourceList.vue'),
    meta: {},
  },
  // Tính chất nguồn kinh phí
  {
    path: '/dictionary/budgesourceproperty',
    name: 'budgetsourceproperty',
    component: () =>
      import(/* webpackChunkName:'di'*/ '@/views/dictionary/budgetSourceProperty/BudgetSourcePropertyList.vue'),
    meta: {},
  },
  // / CTMT, dự án
  {
    path: '/dictionary/project',
    name: 'project',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/dictionary/project/ProjectList.vue'),
    meta: {},
  },
  // Mã dự phòng
  {
    path: '/dictionary/budgetprovide',
    name: 'budgetprovide',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/budgetProvide/BudgetProvideList.vue'),
  },
  // Hệ thống tài khoản
  {
    path: '/dictionary/systemaccounts',
    name: 'systemaccounts',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/systemAccounts/SystemAccountsList.vue'),
  },
  // Kho
  {
    path: '/dictionary/stock',
    name: 'stock',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/stock/StockList.vue'),
  },
  // Kho
  {
    path: '/dictionary/bankinfocategory',
    name: 'bankinfocategory',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/bankInfoCategory/BankInfoCategoryList.vue'),
  },
  // Loại tài sản cố định
  {
    path: '/dictionary/fixedassetcategory',
    name: 'fixedassetcategory',
    component: () =>
      import(/* webpackChunkName:'di'*/ '@/views/dictionary/fixedAssetCategory/FixedAssetCategoryList.vue'),
  },
  {
    path: '/dictionary/accountparallelrule',
    name: 'accountparallelrule',
    component: () =>
      import(/* webpackChunkName:'di'*/ '@/views/dictionary/accountParallelRule/AccountParallelRule.vue'),
    meta: {},
  },
  {
    path: '/dictionary/bankInfo',
    name: 'bankinfo',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/bankInfo/BankInfoList.vue'),
  },
  // Quỹ
  {
    path: '/dictionary/fund',
    name: 'fund',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/fund/FundList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/accounttransfer',
    name: 'accounttransfer',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/accountTransfer/AccountTransferList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/autobusiness',
    name: 'autobusiness',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/autoBusiness/AutoBusinessList.vue'),
    meta: {},
  },

  {
    path: '/dictionary/budgetitemSpend',
    name: 'budgetitemSpend',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/budgetitemSpend/BudgetitemSpendList.vue'),
    meta: {},
  },
  // Tài khoản ngầm định
  {
    path: '/dictionary/defaultaccount',
    name: 'defaultaccount',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/defaultAccount/DefaultAccountList.vue'),
  },
  // Nhóm mục chi
  {
    path: '/dictionary/budgetgroupitem',
    name: 'budgetgroupitem',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/budgetGroupItem/BudgetGroupItemList.vue'),
  },
  // Kho
  {
    path: '/dictionary/stock',
    name: 'stock',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/stock/StockList.vue'),
  },
  // [Danh mục/Kho] Loại vật tư/ ccdc
  {
    path: 'dictionary/inventorycategory',
    name: 'inventorycategory',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/stock/InventoryCategoryList.vue'),
  },
  {
    // Danh mục vật tư
    path: '/dictionary/inventory',
    name: 'inventory',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/stock/inventory/InventoryList.vue'),
    meta: {},
  },
  // Công cụ dụng cụ
  {
    path: '/dictionary/equipmentinventoryitem',
    name: 'equipmentinventoryitem',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/stock/EquipmentInventoryItemList.vue'),
  },
  {
    path: '/dictionary/accountingobjectcategory',
    name: 'accountingobjectcategory',
    component: () =>
      import(/* webpackChunkName:'di'*/ '@/views/dictionary/accountingObjectCategory/AccountingObjectCategoryList.vue'),
    meta: {},
  },
  // {
  //   path: 'dictionary/option',
  //   name: 'option',
  //   component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/salaryScale/paOption/PAOption.vue'),
  // },
  // Cán bộ
  {
    path: '/dictionary/accountingobject',
    name: 'accountingobject',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/accountingObject/AccountingObjectList.vue'),
    meta: {},
  },
  // Danh mục phòng ban
  {
    path: '/dictionary/department',
    name: 'department',
    component: () => import('@/views/dictionary/department/DepartmentList.vue'),
  },
  {
    path: '/dictionary/fixedAsset',
    name: 'fixedAsset',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/fixedAsset/FixedAssetList.vue'),
  },
  // Danh mục danh sách đối tượng
  {
    path: '/dictionary/accountingobjectmasterlist',
    name: 'accountingobjectmasterlist',
    component: () =>
      import(/* webpackChunkName:'di'*/ '@/views/dictionary/accountingObjectList/AccountingObjectMasterList.vue'),
  },
  // [Danh mục/Khác] Hoạt động tài chính
  {
    path: 'dictionary/activity',
    name: 'activity',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/activity/ActivityList.vue'),
  },
  {
    path: 'dictionary/activityCategory',
    name: 'activityCategory',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/activityCategory/ActivityCategoryList.vue'),
  },
  {
    path: 'dictionary/hamlet',
    name: 'hamlet',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/hamlet/HamletList.vue'),
  },
  // Đơn vị trực thuộc
  {
    path: 'dictionary/branch',
    name: 'branch',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/branch/BranchList.vue'),
  },
  // Danh mục mã thống kê
  {
    path: 'dictionary/statistic',
    name: 'statistic',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/statistic/StatisticList.vue'),
  },
  // Danh mục Hợp đồng
  {
    path: 'dictionary/contract',
    name: 'contract',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/contract/ContractList.vue'),
  },
  // Danh mục Khoản chi xã
  {
    path: 'dictionary/localbudgetitem',
    name: 'localbudgetitem',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/localBudgetItem/LocalBudgetItemList.vue'),
  },
  // Tiết tiểu mục
  {
    path: '/dictionary/budgetitemdetail',
    name: 'budgetitemdetail',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/subBudgetItem/SubBudgetItemList.vue'),
    meta: {},
  },
  // Danh mục nội dung chi phí
  {
    path: 'dictionary/fundStructure',
    name: 'funcStructure',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/fundStructure/FundStructureList.vue'),
  },
  {
    path: 'access-history',
    name: 'access-history',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/accessHistory/AccessHistory.vue'),
  },
  // Thiết lập ngầm định
  {
    path: 'defaultImplicitSetting',
    name: 'defaultImplicitSetting',
    component: () =>
      import(/* webpackChunkName:'di'*/ '@/views/dictionary/defaultImplicitSetting/DefaultImplicitSetting.vue'),
  },
  // Chế độ ghi sổ
  {
    path: 'regimePosted',
    name: 'regimePosted',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/regimePosted/RegimePosted.vue'),
  },
  // Thiết lập in báo cáo - Báo cáo
  {
    path: 'printreportsetting',
    name: 'printreportsetting',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/printReportSetting/PrintReportSetting.vue'),
  },
  // Nhập khẩu số dư tạm ứng đầu kỳ
  {
    path: 'importExcel',
    name: 'importExcel',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/common/import/ImportExcel.vue'),
  },
  {
    path: '/setting-esign',
    name: '/setting-esign',
    component: () => import('@/views/dictionary/settingEsign/SettingEsign.vue'),
    meta: {},
  },
  // Danh mục Tiêu chuẩn định mức
  {
    path: 'dictionary/expenseNormRegulation',
    name: 'expenseNormRegulation',
    component: () =>
      import(/* webpackChunkName:'di'*/ '@/views/dictionary/expenseNormRegulation/ExpenseNormRegulationList.vue'),
  },
];
